import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetVendorsList = () => {
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalLength, setTotalLength] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [filter, setFilter] = useState(1);

  const getVendors = async () => {
    if (search === "") {
      setIsLoading(true);
    }
    try {
      let data = await TLinkApi.get(
        `/vendors?search=${search}&page=${page}&limit=${entriesPerPage}&is_active=${
          filter === -1 ? "" : Number(filter) === 1 ? true : false
        }`
      );
      setVendors(data?.data?.data || []);
      setTotalLength(Number(data?.data?.totalLength));
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };
  useEffect(() => {
    getVendors();
    // eslint-disable-next-line
  }, [page, search, entriesPerPage, filter]);
  return {
    vendors,
    getVendors,
    isLoading,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    setEntriesPerPage,
    entriesPerPage,
    filter,
    setFilter,
  };
};

export default GetVendorsList;
